import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@nykaa/nes-ui-components';
import stringTranslations from '@nykaa/nes-intl-shared/constants/lang.data.json';
import List from '@nykaa/nes-reco-widget';
import { ListingProduct } from '@nykaa/nes-product-card-shared/types';
import { fetchRecentlyViewedProducts } from 'store/searchSuggestions/action';
import { State } from 'store/types';
import { getRecenltyViewedProductsFromLocal } from 'helpers/utils/product';
import { getRecommendationsUrl } from 'helpers/utils/url';
import { PageRootTypes } from 'constants/dataLayer';

const generateProductIDs = (): string => {
  const recentlyViewedList = getRecenltyViewedProductsFromLocal();
  return recentlyViewedList.reverse().join(',');
};

const Root = styled.div`
  > div {
    margin: ${({ theme }) => theme.spacing.spacing0};
    > div:first-child {
      padding: ${({ theme }) => theme.spacing.spacing80};
      ${({ theme }) => theme.typography.titleXSmall};
    }
  }
`;

const RecentlyViewed = () => {
  const dispatch = useDispatch();
  const { recentlyViewed = [] } = useSelector(
    (state: State) => state.searchSuggestions
  );
  const { searchBoxRecentlyViewedWidget } = useSelector(
    (state: State) => state.remoteConfig?.configs
  );
  const optimizedImageUrlEnabled = useSelector(
    (state: State) => state?.remoteConfig?.switches?.optimizedImageUrlEnabled
  );
  const langConfig = useSelector((state: State) => state.langConfig);
  const [viewedProducts, setViewedProducts] = useState<ListingProduct[]>([]);

  const {
    isExperimentEnabled: isVernacularEnabled,
    lang: actualLang,
    strings = stringTranslations,
  } = langConfig || {};
  const translationStrings = strings[actualLang];
  const { OUT_OF_STOCK, FEW_LEFT, LEFT, OFF, SHADES, SHADE, SIZE, SIZES } =
    translationStrings;
  const translationString = {
    OUT_OF_STOCK,
    FEW_LEFT,
    LEFT,
    OFF,
    SHADES,
    SHADE,
    SIZE,
    SIZES,
  };

  useEffect(() => {
    const productIDs = generateProductIDs();
    if (productIDs) {
      fetchRecentlyViewedProducts(productIDs)(dispatch);
    }
  }, [dispatch]);

  useEffect(() => {
    if (recentlyViewed.length) {
      let inStockProducts: ListingProduct[] = [];
      inStockProducts = recentlyViewed.filter((product) => product.inStock);
      setViewedProducts(inStockProducts);
    }
  }, [recentlyViewed]);

  if (!viewedProducts.length) {
    return null;
  }

  return (
    <Root>
      <List
        title={searchBoxRecentlyViewedWidget}
        products={viewedProducts}
        design="horizontal_slider"
        recommendationId="recently-viewed-products-section"
        hideCTA={true}
        getPdpUrl={(slug: string, position?: number) =>
          getRecommendationsUrl({
            slug: slug || 'l',
            root: PageRootTypes.SEARCH_BOX,
            position,
          })
        }
        translationString={translationString}
        isExperimentEnabled={isVernacularEnabled}
        optimizedImageUrlEnabled={optimizedImageUrlEnabled}
      />
    </Root>
  );
};

export default RecentlyViewed;
